import script from "./DirectiveDocumentViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectiveDocumentViewer.vue?vue&type=script&setup=true&lang=js"

import "./DirectiveDocumentViewer.vue?vue&type=style&index=0&id=f8701e4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8701e4a"]])

export default __exports__